<ng-container *ngIf="DataSource$ | async as DataSource">
    <div class="row" *ngIf="chipsetDataToShow.length > 0">
        <div class="col-auto" *ngFor="let chipSet of chipsetDataToShow">
            <div class="d-flex me-auto rounded border border-dark">
                <span class="fs-5 fw-semibold p-2 border border-dark border-left-0 border-top-0 border-bottom-0">{{
                    chipSet.displayName }}</span>
                <span class="py-2 px-3 cursor-default align-content-center">
                    {{ chipSet.displayString }}
                </span>
            </div>
        </div>
        <div class="align-self-center btn btn-sm btn-icon btn-danger py-2 px-3 rounded col-auto"
            matTooltip="{{'lib.CLEAR_FILTERS' | translate}}" (click)="onChipSetClear.emit()">
            <i class="fa-times fas"></i>
        </div>
    </div>
    <div class="col-auto ms-auto">
        <mat-paginator lang="pt" *ngIf="showPagination && paginationPosition == 'top'" [length]="DataSource.totalItems"
            [pageIndex]="DataSource.pagination.page-1" [pageSize]="DataSource.pagination.pageSize"
            [pageSizeOptions]="[5, 10, 25, 100]" (page)="handlePageEvent($event)">
        </mat-paginator>
    </div>

    <div style="position: relative;">
        <div class="table-wrapper" [class.no-scroll]="DataSource.body?.length === 0 || errorOnDataRetrieve"
            [class.table-min-height]="showLoader">
            <table class="table mb-0" style="width: max-content; min-width: 100%;">
                <!-- Table Header -->
                <thead class="fs-7 text-muted">
                    <tr>
                        <th *ngIf="DataSource.selectableRows?.show"></th>
                        <th scope="col" class="align-content-center" *ngFor="let column of dataSourceColumnsToShow(); trackBy: trackByColumn">
                            <div class="flex items-center cursor-pointer"
                                [class.table-sort-desc]="column.direction === 'desc' && !DataSource.disableOrder"
                                [class.table-sort-asc]="column.direction === 'asc' && !DataSource.disableOrder"
                                [class.cursor-pointer]="!DataSource.disableOrder"
                                (click)="!DataSource.disableOrder ? onClickOrderBy(column) : null"
                                [class]="(column.width === 'auto' ? '' : column.width) + ' ' + (getAlignmentClass(column))">
                                <span>{{column.title}}</span>
                            </div>
                        </th>
                        <th class="min-w-70px px-0" scope="col">
                            <div class="d-flex justify-content-center">
                                <span>{{ 'lib.ACTIONS' | translate}}</span>
                                <!--<button type="button" class="btn btn-icon btn-active-color-secondary btn-sm" *ngIf="DataSource.filterRow"
                            (click)="filterSearch()">
                            <i class="fa-solid fa-magnifying-glass text-white"></i>
                            </button>
                            <button type="button" class="btn btn-icon btn-active-color-secondary btn-sm" *ngIf="DataSource.filterRow"
                                (click)="cleanForm()">
                                <i class="fa-solid fa-eraser text-white"></i>
                            </button>
                            <button type="button" class="btn btn-icon btn-active-color-secondary btn-sm"
                                (click)="DataSource.filterRow = !DataSource.filterRow" *ngIf="!DataSource.hideFilters">
                                <i class="fa-solid fa-filter-circle-xmark text-white" *ngIf="DataSource.filterRow"></i>
                                <i class="fa-solid fa-filter text-white" *ngIf="!DataSource.filterRow"></i>
                            </button>
                            <button type="button" class="btn btn-icon btn-active-color-secondary btn-sm" #reorderButton
                                (click)="reorderMenu = !reorderMenu">
                                <i class="fa-solid fa-table-layout text-white" *ngIf="!reorderMenu"></i>
                                <i class="fa-solid fa-table-layout text-white" *ngIf="reorderMenu"></i>
                            </button>
                            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="reorderButton" [cdkConnectedOverlayOpen]="reorderMenu" [cdkConnectedOverlayPositions]="menuPosition" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'" [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="reorderMenu = false">
                                <div class="bg-white rounded shadow-lg d-flex flex-wrap" style="width: 200px;" cdkDropList (cdkDropListDropped)="drop($event)">
                                    <div *ngFor="let columnDetail of tableDetails; let isLast = last; let isFirst = first" cdkDrag class="col-12 d-flex border border-secondary p-2 bg-white drag-item text-gray-600 fw-bold fs-7" [ngClass]="{ 'rounded-top': isFirst, 'rounded-bottom': isLast && !tableDetailsChanged}">
                                        <span class="me-auto col-9">
                                            {{columnDetail.title}}
                                        </span>
                                        <span class="ms-auto col-3 align-content-center">
                                            <i (click)="visibilityToggle(columnDetail)" class="fa-solid ms-3" style="cursor: pointer" [ngClass]="columnDetail.show ? 'fa-eye' : 'fa-eye-slash'"></i>
                                            <i class="fa-solid fa-bars draggable ms-3" cdkDragHandle></i>
                                        </span>
                                    </div>
                                    <div *ngIf="tableDetailsChanged" cdkDrag class="col-12 d-flex border border-secondary p-2 bg-white drag-item text-gray-600 fw-bold fs-7 rounded-bottom">
                                        <span class="ms-auto w-100">
                                            <button class="btn btn-sm btn-icon btn-success text-white w-100" [matTooltip]="'lib.SAVE_CHANGES' | translate" (click)="saveTableDetails()">
                                                <i class="fas fa-floppy-disk"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </ng-template>-->
                            </div>
                        </th>
                    </tr>

                    <!-- Filters -->
                    <tr class="bg-white border-b-2 filter-row" *ngIf="filtersForm && DataSource.filterRow">
                        <th *ngIf="DataSource.selectableRows?.show" class="text-center ps-2">
                            <input *ngIf="DataSource.selectableRows?.selectMultipleRows" class="form-check-input ms-4"
                                type="checkbox" (change)="selectAllRows()">
                        </th>
                        <ng-container *ngFor="let column of dataSourceColumnsToShow(); let l = last; trackBy: trackByColumn">
                            <th class="p-1" [class]="column.type.type === 'date' ? 'min-w-225px' : column.width">
                                <!-- TODO table filters row with column filter type instead of column type -->
                                <!-- START: Filters -->
                                <form [formGroup]="filtersForm">
                                    <!-- START: TEXT -->
                                    <input type="text" class="form-control form-control-solid form-control-sm"
                                        *ngIf="column.type.type === 'text' || column.type.type === 'link'"
                                        formControlName="{{column.identifier}}" (keyup.enter)="filterSearch()"
                                        [placeholder]="'lib.SEARCH' | translate" />
                                    <!-- END: TEXT -->

                                    <!-- START: DATE -->
                                    <ng-container *ngIf="column.type.type === 'date'">
                                        <!-- <p-calendar formControlName="{{column.identifier}}" inputStyleClass="is-input" dateFormat="dd/mm/yy" placeholder="Procurar" appendTo="body" selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar> -->
                                        <is-date-time-picker [smallInput]="true" [Type]="dateType"
                                            formControlName="{{column.identifier}}"
                                            (selectionChange)="filterSearch()"></is-date-time-picker>
                                    </ng-container>
                                    <!-- END: DATE -->

                                    <!-- START: DATE RANGE -->
                                    <ng-container *ngIf="column.type.type === 'dateRange' || column.type.type === 'dateTime'">
                                        <!-- <p-calendar formControlName="{{column.identifier}}" inputStyleClass="is-input" dateFormat="dd/mm/yy" placeholder="Procurar" appendTo="body" selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar> -->
                                        <is-date-time-picker [smallInput]="true" [Type]="dateRangeType"
                                            formControlName="{{column.identifier}}"
                                            (selectionChange)="filterSearch()"></is-date-time-picker>
                                    </ng-container>
                                    <!-- END: DATE RANGE -->

                                    <!-- START: Select -->
                                    <ng-container *ngIf="column.type.type === 'select' || column.type.type === 'boolean'">
                                        <div>
                                            <is-select formControlName="{{column.identifier}}"
                                                [placeholder]="'lib.SEARCH' | translate"
                                                [Options]="column.options"></is-select>
                                        </div>
                                    </ng-container>
                                    <!-- END: Select -->

                                    <!-- START: MultiSelect -->
                                    <ng-container *ngIf="column.type.type === 'multiselect'">
                                        <div>
                                            <is-multi-select formControlName="{{column.identifier}}"
                                                [emitChangeOnClose]="true" [placeholder]="'lib.SEARCH' | translate"
                                                [options]="column.options"></is-multi-select>
                                        </div>
                                    </ng-container>
                                    <!-- END: MultiSelect -->

                                    <ng-container *ngIf="column.type.type === 'rating'">
                                        <mat-select formControlName="{{column.identifier}}"
                                            (selectionChange)="filterSearch()" [placeholder]="'lib.SEARCH' | translate"
                                            class="form-control form-control-solid form-control-sm">
                                            <mat-option [value]="null"></mat-option>
                                            <ng-container *ngFor="let rating of ratings">
                                                <mat-option [value]="rating">
                                                    <span class="text-gray-600 fw-bold fs-7">
                                                        <span style="margin-right: 5px;">{{rating}}</span>
                                                        <i class="fas fa-star" style="color: #fbf309;"></i>
                                                    </span>
                                                </mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </ng-container>

                                    <ng-container *ngIf="column.type.type === 'country'">
                                        <mat-select formControlName="{{column.identifier}}"
                                            (selectionChange)="filterSearch()" [placeholder]="'lib.SEARCH' | translate"
                                            class="form-control form-control-solid form-control-sm">
                                            <mat-option [value]="null"></mat-option>
                                            <ng-container *ngFor="let country of countries">
                                                <mat-option [value]="country.name">
                                                    <span class="text-gray-600 fw-bold">
                                                        <div class="d-flex flex-row">
                                                            <img [src]="country.flag" class="w-6 flag"
                                                                style="width: 20px; margin-right: 5px;" />
                                                            <span>{{country.name}}</span>
                                                        </div>
                                                    </span>
                                                </mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </ng-container>

                                    <!-- START: Labels -->
                                    <ng-container *ngIf="column.type.type === 'labels'">
                                        <mat-select formControlName="{{column.identifier}}"
                                            (selectionChange)="filterSearch()" [placeholder]="'lib.SEARCH' | translate"
                                            class="form-control form-control-solid form-control-sm">
                                            <mat-select-trigger>
                                                <span class="text-muted">{{getLabel(column.filterOptions.value,
                                                    column.labelOptions, 'Label')}}</span>
                                            </mat-select-trigger>
                                            <mat-option [value]="null" class="small"></mat-option>
                                            <mat-option *ngFor="let option of column.labelOptions"
                                                [value]="option.value">
                                                <span class="badge"
                                                    [ngClass]="('badge-' + option.style)">{{option.label}}</span>
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                    <!-- END: Labels -->

                                    <!-- START: PERCENT -->
                                    <input type="text" class="form-control form-control-solid form-control-sm"
                                        *ngIf="column.type.type === 'percent'" formControlName="{{column.identifier}}"
                                        (keyup.enter)="DataSource.apiUrl ? getDataFromTheAPI(DataSource.apiUrl) : ''"
                                        [placeholder]="'lib.SEARCH' | translate" />
                                    <!-- END: PERCENT -->

                                </form>
                                <!-- END: Filters -->
                            </th>
                        </ng-container>
                        <th></th>
                    </tr>
                </thead>

                <!-- Table Body -->
                <tbody class="fs-7 text-gray-700 fw-semibold">
                    <tr style="display:none"></tr>
                    <ng-container *ngIf="DataSource$ | async as DataSource">
                        <ng-container *ngIf="!showLoader && !errorOnDataRetrieve">
                            <tr *ngFor="let item of DataSource.body; let i = index" [class.selected]="item.selected">
                                <td *ngIf="DataSource.selectableRows?.show">
                                    <input class="form-check-input" type="checkbox" [checked]="item.selected"
                                        (change)="onSelectedRows(i, item)">
                                </td>
                                <!-- Table Data -->
                                <td class="" *ngFor="let column of dataSourceColumnsToShow(); trackBy: trackByColumn"
                                    [class]="getAlignmentClass(column)">
                                    <span [ngSwitch]="column.type.type">
                                        <!-- Date -->
                                        <p *ngSwitchCase="'date'" class=""
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container *ngIf="column.prefix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.prefix | prefixSuffix: item }}
                                            </ng-container>

                                            <ng-container *ngIf="column.applyPipe && !columnIsEmpty(item[column.identifier])">
                                                {{ item[column.identifier] | date: column.type.format ?? 'dd/MM/yyyy' }}
                                            </ng-container>

                                            <ng-container *ngIf="!column.applyPipe && !columnIsEmpty(item[column.identifier])">
                                                {{ item[column.identifier] }}
                                            </ng-container>

                                            <ng-container *ngIf="columnIsEmpty(item[column.identifier])">
                                                -
                                            </ng-container>

                                            <ng-container
                                                *ngIf="column.suffix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.suffix | prefixSuffix: item }}
                                            </ng-container>
                                        </p>

                                        <!-- Date with hour -->
                                        <p *ngSwitchCase="'dateTime'" [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container *ngIf="column.prefix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.prefix | prefixSuffix: item }}
                                            </ng-container>

                                            <ng-container *ngIf="column.applyPipe && !columnIsEmpty(item[column.identifier])">
                                                {{ item[column.identifier] | date: column.type.format ?? 'dd/MM/yyyy - HH:mm'}}
                                            </ng-container>

                                            <ng-container *ngIf="!column.applyPipe && !columnIsEmpty(item[column.identifier])">
                                                {{item[column.identifier]}}
                                            </ng-container>

                                            <ng-container *ngIf="columnIsEmpty(item[column.identifier])">
                                                -
                                            </ng-container>

                                            <ng-container *ngIf="column.suffix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.suffix | prefixSuffix: item }}
                                            </ng-container>
                                        </p>

                                        <!-- Date range -->
                                        <p *ngSwitchCase="'dateRange'" [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container *ngIf="column.prefix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.prefix | prefixSuffix: item }}
                                            </ng-container>

                                            <ng-container *ngIf="column.applyPipe && !columnIsEmpty(item[column.identifier])">
                                                {{ item[column.identifier] | date: column.type.format ?? 'dd/MM/yyyy' }}
                                            </ng-container>

                                            <ng-container *ngIf="!column.applyPipe && !columnIsEmpty(item[column.identifier])">
                                                {{ item[column.identifier] }}
                                            </ng-container>

                                            <ng-container *ngIf="columnIsEmpty(item[column.identifier])">
                                                -
                                            </ng-container>

                                            <ng-container *ngIf="column.suffix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.suffix | prefixSuffix: item }}
                                            </ng-container>
                                        </p>

                                        <!-- Rating -->
                                        <p *ngSwitchCase="'rating'" [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <span class="fa-stack">
                                                <!-- The icon that will wrap the number -->
                                                <span class="fa fa-star fa-stack-2x" style="font-size: 30px;" [ngStyle]="{
                                                'color': item[column.identifier] != null ? item[column.identifier] < 3 ? '#fff2f1' : item[column.identifier] < 8 ? '#fef9de' : '#e8fff3' : '#fff2f1'
                                            }"></span>
                                                <!-- a strong element with the custom content, in this case a number -->
                                                <strong class="fa-stack-1x" style="font-size:80%; margin-top: 2px;"
                                                    [ngStyle]="{'color': item[column.identifier] != null ? item[column.identifier] < 3 ? '#f34b6e' : item[column.identifier] < 8 ? '#fdca32' : '#4ccc8b' : '#f34b6e'}">
                                                    <ng-container *ngIf="item[column.identifier]">
                                                        {{item[column.identifier]}}
                                                    </ng-container>
                                                    <ng-container *ngIf="!item[column.identifier]">
                                                        -
                                                    </ng-container>
                                                </strong>
                                            </span>
                                        </p>

                                        <!-- Number -->
                                        <p *ngSwitchCase="'number'" class="text-start"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container *ngIf="column.prefix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.prefix | prefixSuffix: item }}
                                            </ng-container>

                                            <ng-container *ngIf="!column.confidencialContent">
                                                {{ item[column.identifier] | number: column.type.format | emptyCheck }}
                                            </ng-container>

                                            <ng-container *ngIf="column.suffix && !columnIsEmpty(item[column.identifier])">
                                                {{ column.suffix | prefixSuffix: item }}
                                            </ng-container>
                                        </p>

                                        <!-- Number badge -->
                                        <p *ngSwitchCase="'numberBadge'" class="text-start"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <span class="badge text-center badge-secondary">
                                                <ng-container *ngIf="column.prefix && !columnIsEmpty(item[column.identifier])">
                                                    {{ column.prefix | prefixSuffix: item }}
                                                </ng-container>

                                                <!-- if value is '-', still shows prefix or suffix -->
                                                <ng-container *ngIf="item[column.identifier] != '-'">
                                                    {{ item[column.identifier] | number: column.type.format | emptyCheck }}
                                                </ng-container>
                                                <ng-container *ngIf="item[column.identifier] == '-'">-</ng-container>

                                                <ng-container *ngIf="column.suffix && !columnIsEmpty(item[column.identifier])">
                                                    {{ column.suffix | prefixSuffix: item }}
                                                </ng-container>
                                            </span>
                                        </p>

                                        <!-- Labels -->
                                        <p *ngSwitchCase="'labels'" class="text-start"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <span>
                                                <span class="badge"
                                                    [ngClass]="getLabel(item[column.identifier], column.labelOptions, 'Style')">{{getLabel(item[column.identifier],
                                                    column.labelOptions, 'Label')}}</span>
                                            </span>
                                        </p>

                                        <!-- Country flag -->
                                        <p *ngSwitchCase="'country'" class="text-center"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <span *ngIf="item[column.identifier]" class="text-center">
                                                <ng-container
                                                    *ngFor="let country of getRecordCountries(item[column.identifier])">
                                                    <img [src]="getCountryFlag(country)" class="w-6 flag"
                                                        style="width: 25px; margin-right: 5px;" />
                                                </ng-container>
                                            </span>
                                            <span *ngIf="!item[column.identifier]">
                                                -
                                            </span>
                                        </p>

                                        <!-- Picture -->
                                        <p *ngSwitchCase="'picture'" class="text-center"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <img *ngIf="!item[column.identifier]"
                                                [src]="'/assets/images/avatars/blank.svg'"
                                                style="width: 40px;height: 40px; border-radius: 50%;">
                                            <img *ngIf="item[column.identifier]"
                                                [src]="'data:image/png;base64,' + item[column.identifier]"
                                                style="width: 40px;height: 40px; border-radius: 50%;">
                                        </p>

                                        <!-- Boolean -->
                                        <p *ngSwitchCase="'boolean'" class="text-center"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <span *ngIf="item[column.identifier]">
                                                <span class="badge badge-light-success">
                                                    {{ getBooleanOptionLabel(item[column.identifier], column) ?? 'Sim'
                                                    }}
                                                </span>
                                            </span>
                                            <span *ngIf="!item[column.identifier]">
                                                <span class="badge badge-light-danger">
                                                    {{ getBooleanOptionLabel(item[column.identifier], column) ?? 'Não'
                                                    }}
                                                </span>
                                            </span>
                                        </p>

                                        <!-- Select -->
                                        <!-- <p *ngSwitchCase="'select'" class="text-start d-flex align-items-center justify-content-center" -->
                                        <p *ngSwitchCase="'select'" [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container *ngIf="getOptionIcon(item[column.identifier], column)">
                                                <i class="fa-solid fa-fw text-align-center"
                                                    [title]="getOptionLabel(item[column.identifier], column)"
                                                    [ngClass]="'fa-' + getOptionIcon(item[column.identifier], column)"></i>
                                            </ng-container>

                                            <ng-container *ngIf="!getOptionIcon(item[column.identifier], column)">
                                                <span class="">
                                                    {{getOptionLabel(item[column.identifier], column)}}
                                                </span>
                                            </ng-container>
                                        </p>

                                        <!-- Multi select -->
                                        <p *ngSwitchCase="'multiselect'" class="text-start"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container *ngIf="getOptionIcon(item[column.identifier], column)">
                                                <i class="fa-solid fa-fw"
                                                    [title]="getOptionLabel(item[column.identifier], column)"
                                                    [ngClass]="'fa-' + getOptionIcon(item[column.identifier], column)"></i>
                                            </ng-container>

                                            <ng-container *ngIf="!getOptionIcon(item[column.identifier], column)">
                                                <span class=""
                                                    [ngClass]="getOptionStyle(item[column.identifier], column)">
                                                    {{getOptionLabel(item[column.identifier], column)}}
                                                </span>
                                            </ng-container>
                                        </p>

                                        <!-- Percentage -->
                                        <p *ngSwitchCase="'percent'" class="text-center"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container>
                                                {{ item[column.identifier] ? item[column.identifier] + '%' : ' - ' }}
                                            </ng-container>
                                        </p>

                                        <!-- Link -->
                                        <a *ngSwitchCase="'link'" class=""
                                            (mousedown)="handleLinkEvent(column, item, $event);"
                                            [class.text-center]="!item[column.identifier]"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <p class="link">
                                                <ng-container *ngIf="column.prefix && item[column.identifier]">
                                                    {{column.prefix | prefixSuffix: item}}
                                                </ng-container>

                                                <ng-container
                                                    *ngIf="column.confidencialContent && item[column.identifier]">
                                                    {{item[column.identifier] | hideText:
                                                    column.confidencialContent.startCharsToHide:
                                                    column.confidencialContent.middleCharsToHide :
                                                    column.confidencialContent.endCharsToHide: '*'}}
                                                </ng-container>

                                                <ng-container *ngIf="!column.confidencialContent">
                                                    {{item[column.identifier] | emptyCheck}}
                                                </ng-container>

                                                <ng-container *ngIf="column.suffix && item[column.identifier]">
                                                    {{column.suffix | prefixSuffix: item }}
                                                </ng-container>
                                            </p>
                                        </a>

                                        <!-- Icon -->
                                        <a *ngSwitchCase="'icon'" class=""
                                            [class.text-center]="!item[column.identifier]"
                                            [matTooltipDisabled]="!columnHasTooltip(column, item)" [matTooltip]="column.tooltipFn || column.tooltipField || column.alternativeIdentifier
                                        ? getColumnTooltipText(column, item)
                                        : (column.tooltipText! | translate)">

                                            <ng-container *ngIf="getColumnIcon(item, column) as icon; else noIcon">
                                                <i *ngIf="!column.alternativeIdentifier" [class]="icon + ' col'"></i>

                                                <i *ngIf="column.alternativeIdentifier" [class]="icon + ' col'">
                                                </i>

                                                <span class="col" *ngIf="column.suffix && item[column.identifier]">
                                                    {{ column.suffix | prefixSuffix: item }}
                                                </span>
                                            </ng-container>

                                            <ng-template #noIcon>
                                                -
                                            </ng-template>
                                        </a>

                                        <!-- Default -->
                                        <p *ngSwitchDefault
                                            [class.text-center]="column.align == 'left' && columnIsEmpty(item[column.identifier]) && ((column.subscript | prefixSuffix: item) | emptyCheck) == '-'"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <ng-container
                                                *ngIf="column.prefix && !columnIsEmpty(item[column.identifier])">
                                                {{column.prefix | prefixSuffix: item}}
                                            </ng-container>

                                            <ng-container *ngIf="column.confidencialContent && item[column.identifier]">
                                                {{item[column.identifier] | hideText:
                                                column.confidencialContent.startCharsToHide:
                                                column.confidencialContent.middleCharsToHide :
                                                column.confidencialContent.endCharsToHide: '*'}}
                                            </ng-container>

                                            <ng-container *ngIf="!column.confidencialContent">
                                                {{item[column.identifier] | emptyCheck}}
                                            </ng-container>

                                            <ng-container
                                                *ngIf="column.suffix && !columnIsEmpty(item[column.identifier])">
                                                {{column.suffix | prefixSuffix: item }}
                                            </ng-container>
                                        </p>

                                        <!-- Sub script -->
                                        <ng-container *ngIf="column.subscript"
                                            [matTooltipDisabled]="!columnHasTooltip(column)"
                                            [matTooltip]="column.tooltipText! | translate">
                                            <p class="additional-info">
                                                {{ column.subscript | prefixSuffix: item }}
                                            </p>
                                        </ng-container>
                                    </span>
                                </td>

                                <!-- Actions Buttons -->
                                <td class="px-2">
                                    <span class="d-flex flex-row gap-3 justify-content-center">
                                        <ng-container *ngFor="let btn of DataSource.columnBtns">
                                            <!-- Single Button -->
                                            <a *ngIf="!btn.childrens" class="table-btn"
                                                [matTooltip]="btn.tooltip && (btn.tooltip != '') ? (btn.tooltip | translate) : ''"
                                                [ngClass]="btn.styling != null ? btn.styling : 'text-muted'"
                                                (click)="onClickButtonAction(btn.type, item)">
                                                <i class="fa-solid fa-fw fa-{{btn.icon}}"></i>
                                            </a>

                                            <!-- Menu Button -->
                                            <div *ngIf="btn.childrens">
                                                <a class="me-1"
                                                    [matTooltip]="btn.tooltip && (btn.tooltip != '') ? (btn.tooltip | translate) : ''"
                                                    [ngClass]="btn.styling != null ? btn.styling : 'text-muted'"
                                                    [matMenuTriggerFor]="childrensMenu">
                                                    <i class="fa-solid fa-fw fa-{{btn.icon}}"></i>
                                                </a>

                                                <mat-menu #childrensMenu>
                                                    <div class="d-flex flex-row justify-content-center">
                                                        <ng-container *ngFor="let childBtn of btn.childrens">
                                                            <a class="me-1 text-center"
                                                                [matTooltip]="btn.tooltip && (btn.tooltip != '') ? (btn.tooltip | translate) : ''"
                                                                [ngClass]="btn.styling != null ? btn.styling : 'text-muted'"
                                                                (click)="onClickButtonAction(childBtn.type, item)">
                                                                <i class="fa-solid fa-fw fa-{{childBtn.icon}}"></i>
                                                            </a>
                                                        </ng-container>
                                                    </div>
                                                </mat-menu>
                                            </div>
                                        </ng-container>
                                        <!-- <button type="button" class="btn btn-icon" (click)="onClickButtonAction(btn.type, item)">
                                        <mat-icon [fontIcon]="btn.Icon"></mat-icon>
                                    </button> -->
                                    </span>
                                </td>
                            </tr>
                        </ng-container>
                        <!-- EMPTY -->
                        <tr *ngIf="!errorOnDataRetrieve && DataSource.body?.length === 0 && !showLoader">
                            <td class="table-empty-state"
                                [attr.colspan]="DataSource.columns.length + (DataSource.columnBtns ? 1 : 0)">
                                <div class="table-empty-content">
                                    <div class="table-empty-text">
                                        <span class="text-gray-700 small fw-medium"
                                            [innerHTML]="(customEmptyMessage ?? 'lib.NO_RECORDS_FOUND' ) | translate"></span>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <!-- ERROR -->
                        <tr *ngIf="errorOnDataRetrieve && !showLoader">
                            <td class="table-empty-state"
                                [attr.colspan]="DataSource.columns.length + (DataSource.columnBtns ? 1 : 0)">
                                <div class="table-empty-content">
                                    <div class="table-empty-text">
                                        <span class="text-gray-700 small fw-medium">{{'lib.ERROR_GETTING_DATA' |
                                            translate}}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        
        <!-- Overlay Loader -->
        <div *ngIf="showLoader" class="table-loader-overlay">
            <div class="table-loader-overlay__content">
                <ngx-spinner [name]="tableKey" class="table-loader-overlay__spinner" bdColor="rgba(255,255,255,0)"
                    size="small" color="var(--kt-input-group-addon-color)" type="ball-pulse" [fullScreen]="false">
                </ngx-spinner>
            </div>
        </div>
    </div>

    <div *ngIf="!showLoader">
        <mat-paginator lang="pt"
            *ngIf="showPagination && !errorOnDataRetrieve && paginationPosition == 'bottom' && (DataSource.body?.length ?? 0 <= DataSource.pagination.pageSize)"
            [length]="DataSource.totalItems" [pageIndex]="DataSource.pagination.page-1"
            [pageSize]="DataSource.pagination.pageSize" [pageSizeOptions]="[5, 10, 25, 100]"
            (page)="handlePageEvent($event)">
        </mat-paginator>
    </div>
</ng-container>